function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtboard7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.89,
    height: 62.98647,
    viewBox: "0 0 57.89 62.98647",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M55.888,40.98825V21.98825c-.00247-3.74637-2.00233-7.20717-5.24699-9.08L34.19,3.40825c-3.24675-1.87499-7.24725-1.87499-10.494,0L7.245,12.90825c-3.24683,1.87408-5.24702,5.33813-5.24699,9.087v19c-.00003,3.74887,2.00017,7.21292,5.24699,9.087l16.451,9.5c3.24675,1.87498,7.24725,1.87498,10.494,0l16.451-9.5c3.24683-1.87408,5.24702-5.33813,5.24699-9.087",
    style: {
      fill: "#57ba8e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M55.89,40.98624V21.98624c-.00247-3.74637-2.00233-7.20717-5.24699-9.08L34.192,3.40624c-3.24675-1.87499-7.24725-1.87499-10.494,0L7.24699,12.90624c-3.24683,1.87408-5.24702,5.33813-5.24699,9.087v19c-.00003,3.74887,2.00017,7.21292,5.24699,9.087l16.451,9.5c3.24675,1.87498,7.24725,1.87498,10.494,0l16.451-9.5c3.24899-1.87533,5.24953-5.34262,5.24699-9.09399Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M28.07497,36.41307c-1.88611,.25256-3.53949,1.38763-4.453,3.05701-.22107,.42358-.34827,.88983-.37299,1.367-.04651,.74323,.28003,1.46085,.87097,1.914,.27789,.20273,.58984,.35413,.92102,.44699,2.09003,.621,4.97601-.82001,6.021-2.957,.22369-.41357,.3512-.87231,.37299-1.34201,.04651-.74323-.28003-1.46085-.87097-1.914-.27789-.20276-.58978-.35413-.92102-.44699-.5119-.12955-1.04205-.17145-1.56799-.12399",
    style: {
      fill: "#178358"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "g",
    x: 30.62704,
    y: 18.12324,
    width: 0.809,
    height: 20.578,
    rx: 0.07,
    ry: 0.07,
    style: {
      fill: "#178358"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtboard7);
export default __webpack_public_path__ + "static/media/Artboard_7.e925a07d1ee0adef2dd6172da2ae5072.svg";
export { ForwardRef as ReactComponent };